import type { Html, HtmlBuilder } from "foldkit/html";

/**
 * The one tab implementation: DaisyUI `tabs tabs-border` with ARIA wiring.
 * The list must interleave tab, panel, tab, panel (see CLAUDE.md); inactive
 * panels are hidden and not rendered.
 */
export const tabsOf = <M, V extends string>(
	h: HtmlBuilder<M>,
	selected: V,
	onSelect: (value: V) => M,
) => ({
	list: (children: ReadonlyArray<Html>): Html =>
		h.div([h.Role("tablist"), h.Class("tabs tabs-border")], children),
	tab: (value: V, label: string): Html =>
		h.button(
			[
				h.Type("button"),
				h.Role("tab"),
				h.Id(`${value}-tab`),
				h.AriaControls(`${value}-panel`),
				h.AriaSelected(selected === value),
				h.Tabindex(selected === value ? 0 : -1),
				h.Class(`tab${selected === value ? " tab-active" : ""}`),
				h.OnClick(onSelect(value)),
			],
			[label],
		),
	panel: (value: V, content: () => Html): Html =>
		h.div(
			[
				h.Id(`${value}-panel`),
				h.Role("tabpanel"),
				h.AriaLabelledBy(`${value}-tab`),
				h.Class("tab-content pt-6"),
				h.Hidden(selected !== value),
			],
			[selected === value ? content() : h.empty],
		),
});
